'use strict';
const _ = require('underscore'),
	isEmptyGroup = require('../../content/is-empty-group'),
	outlineUtils = require('../standard/outline'),
	standardCalculator = require('../standard/tree'),
	calculateTree = function (content, dimensionProvider, margin, level, currentRank, layout) {

		const angleDegrees = Number.isFinite(layout?.angleDegrees) ? layout?.angleDegrees : 30,
			options = {
				id: content.id,
				title: content.title,
				attr: content.attr,
				deltaY: 0,
				deltaX: 0,
				level: level || 1,
				rank: currentRank || 1,
				piRads: Math.abs(angleDegrees / 180)
			},
			nodeDimensions = dimensionProvider(content, options.level),
			shouldIncludeSubIdeas = function () {
				return !(_.isEmpty(content.ideas) || (content.attr && content.attr.collapsed));
			},
			appendSubtrees = function (subtrees) {

				if (level === 1) {
					const maxSize = subtrees.reduce((accumulated, current) => {
							const subSize = current.outline.calcSize();
							return {
								height: Math.max(accumulated.height, subSize.height),
								width: Math.max(accumulated.width, subSize.width + 2 * margin.h)
							};
						}, {width: 100, height: 100}),
						alignmentWidth = nodeDimensions.bubble ? nodeDimensions.bubble.width: nodeDimensions.width,
						alignmentHeight = nodeDimensions.bubble ? nodeDimensions.bubble.height : nodeDimensions.height,
						sortedSubtrees = subtrees.slice().sort((a, b) => Math.abs(a.rank) - Math.abs(b.rank)),
						subtreesAbove = sortedSubtrees.filter(t => t.rank >= 0),
						subtreesBelow = sortedSubtrees.filter(t => t.rank < 0),
						subtreeOffset = Math.tan(Math.PI * options.piRads) * (maxSize.height + margin.v);
					subtreesAbove.forEach((subtree, idx) => {
						const subtreeNodeHeight = subtree.bubble?.height || subtree.height;
						subtree.deltaY = -1 * (maxSize.height + margin.v) - subtreeNodeHeight;
						subtree.deltaX = ((maxSize.width + margin.h) * idx) + alignmentWidth + subtreeOffset +  margin.h;
					});
					subtreesBelow.forEach((subtree, idx) => {
						subtree.deltaY = maxSize.height + margin.v + alignmentHeight;
						subtree.deltaX = ((maxSize.width + margin.h) * idx) + alignmentWidth + subtreeOffset + margin.h;
					});

				} else if (level === 2) {
					const sortedSubtrees = subtrees.slice().sort((a, b) => Math.abs(a.rank) - Math.abs(b.rank)),
						orderedSubtrees = options.rank > 0 ? sortedSubtrees : sortedSubtrees.reverse(),
						parentSize = nodeDimensions.bubble || nodeDimensions,
						allowanceForParentAlignment = options.rank < 0 ? 0 : parentSize.height,
						totalSize = orderedSubtrees.reduce((previousSize, subtree) => {
							const subSize = subtree.outline.calcSize(),
								newTreeHeight = previousSize.height + subSize.height + margin.v,
								newTreeWidth = Math.max(previousSize.width, subSize.width),
								halfBubbleHeight = (subtree.bubble ? subtree.bubble.height : subtree.height) / 2,
								newTreeMidPoint = newTreeHeight - subSize.height / 2,
								shiftLeftComparedToParent = () => {
									const calcOffsetY = newTreeMidPoint - halfBubbleHeight - allowanceForParentAlignment,
										offsetX = Math.tan(Math.PI * options.piRads) * (calcOffsetY);
									return -1 * offsetX;
								},
								indentation = shiftLeftComparedToParent() +	 margin.h,
								setSubtreeTopAt = (options.rank < 0) ? (Math.sign(options.rank) * newTreeHeight) : previousSize.height + margin.v;
							subtree.deltaY = setSubtreeTopAt + subSize.height / 2 - halfBubbleHeight;
							subtree.deltaX = indentation;
							return {height: newTreeHeight, width: Math.max(previousSize.width, newTreeWidth /*+ indentation*/)};
						}, {height: allowanceForParentAlignment, width: parentSize.width});
					options.outline =  outlineUtils.outlineFromDimensions(totalSize);
				} else {
					throw 'this should not happen';
				}
			}; //<appendSubtrees end
		if (Number.isFinite(options.level) && options.level > 2) {
			return standardCalculator.calculateTree(content, dimensionProvider, margin, () => true, options.level);
		}
		Object.assign(options, nodeDimensions);
		options.outline = outlineUtils.outlineFromDimensions(nodeDimensions);
		if (shouldIncludeSubIdeas()) {
			const subideasToInclude = Object.entries(content.ideas).filter(kv => !isEmptyGroup(kv[1]));
			options.subtrees = subideasToInclude.map(([rank, subidea]) => Object.assign({rank: parseFloat(rank)}, calculateTree(subidea, dimensionProvider, margin, options.level + 1, rank, layout)));
			if (!_.isEmpty(options.subtrees)) {
				appendSubtrees(options.subtrees);
			}
		}
		return new standardCalculator.Tree(options);
	};

module.exports = {
	Tree: standardCalculator.Tree,
	calculateTree
};
